// import { get_Token } from "util/Helper";
import { toast } from "react-toastify";
import axiosInstance from "../../../../axios";
// Get Student
export const getStudentUserService = async (payload) => {
  console.log("final payload:", payload);
  try {
    // const response = await axiosInstance.get(`/students?keyword=${payload.searchValue}&name=${payload.name}&studentId=${payload.studentId}&enrollmentStatus=${payload.enrollmentStatus}&phoneNumber=${payload.phoneNumber}&country=${payload.country}&email=${payload.email}&isActive=${payload.accessValue}&pageLength=${payload.pageLength}&pageNo=${payload.pageNo}`);
    const response = await axiosInstance.get(`/students`, {
      params: payload,
    });
    return response;
  } catch (e) {
    return { error: e?.response?.message };
  }
};

// Get Student by ID
export const getStudentUserbyIdService = async (id) => {
  try {
    const response = await axiosInstance.get(`/students/${id}`);
    return response;
  } catch (e) {
    return { error: e?.response?.message };
  }
};

// Add Student
export const addStudentUserService = async (payload) => {
  try {
    const response = await axiosInstance.post(`/students`, payload);
    toast.success(response?.data?.message);
    return response;
  } catch (error) {
    return { error: error?.response?.data?.message };
  }
};

//Edit Student
//Edit Student
export const EditStudentUserService = async (payload) => {
  console.log("payload for final api call", payload);
  try {
    const response = await axiosInstance.patch(
      `students/${payload?.studentIdToFetch}`,
      payload?.updatedData
    );
    console.log("payload for final api call  response : ", response);

    // Use setTimeout to show the success message after 2 seconds
    setTimeout(() => {
      toast.success(response?.data?.message);
    }, 1000); // 2000 milliseconds = 2 seconds

    return response;
  } catch (e) {
    return { error: e?.response?.message };
  }
};

// Delete Student
export const deleteStudentUserService = async (payload) => {
  try {
    const response = await axiosInstance.delete(
      `/students/${payload?.studentToDelete}`
    );
    return response;
  } catch (e) {
    return { error: e?.response?.data?.message };
  }
};
